export const FEEDBACKS_GET = 'FEEDBACKS_GET';
export const FEEDBACK_EDIT = 'FEEDBACK_EDIT';
export const FEEDBACK_GET = 'FEEDBACK_GET';
export const FEEDBACK_DELETE = 'FEEDBACK_DELETE';
